import { Component, input, model, output } from '@angular/core';
import { Tab } from '@shared/interfaces';

@Component({
    selector: 'app-tabs',
    imports: [],
    templateUrl: './tabs.component.html',
    styleUrl: './tabs.component.scss',
})
export class TabsComponent {
    /** Tabs input */
    public tabs = input.required<Tab[]>();

    /** Selected tab index two-way binding */
    public selectedTabIndex = model.required<number>();

    /** Emits when a tab is selected */
    public tabClicked = output<Tab>();
}
